import { render, staticRenderFns } from "./ConfigManagement.vue?vue&type=template&id=a28610a2&scoped=true"
import script from "./ConfigManagement.vue?vue&type=script&lang=js"
export * from "./ConfigManagement.vue?vue&type=script&lang=js"
import style0 from "./ConfigManagement.vue?vue&type=style&index=0&id=a28610a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28610a2",
  null
  
)

export default component.exports